import React from 'react';
import styled from 'styled-components/macro';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';

import InputGroup from '../InputGroup';
import TextareaGroup from '../TextareaGroup';
import ReactGoogleAutocomplete from '../InputFields/GoogleMapsAddressField';
import OptInsAndButtonGroup from './OptInsAndButtonGroup';

import submissionErrorHandler from '../../utils/submissionErrorHandler';
import { getCachedFullName } from '../../utils/formCaching/helpers';
import { copyFor, capitalization } from '../../copy/copy';
import validate from './validations';

const DetailsFormContainer = styled.form`
    flex: 1;
    padding: 0;
    display: flex;
    flex-direction: column;
`;

const Row = styled.div`
    margin: 0 -0.5em;
    transition: opacity 0.6s;

    &.focused {
        opacity: 0;

        &.row-wrapper-2 {
            opacity: 1;

            textarea {
                height: 190px;
            }
        }
    }
`;

const FullRow = styled.div`
    width: 100%;
    padding: 0 8px;
    height: ${props => props.isShortRow && '46px'};
`;

class PetitionForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            valid: false,
            messageTextAreaFocused: false,
            errors: submissionErrorHandler(props.currentFormValues, validate)
        };
        this.clearSubmitErrors = this.clearSubmitErrors.bind(this);
        this.setSubmitErrors = this.setSubmitErrors.bind(this);
        this.setValidState = this.setValidState.bind(this);
    }

    componentDidMount() {
        this.setState({ errors: [] });
    }

    setValidState(bool) {
        this.setState({ valid: bool });
    }

    setSubmitErrors(errors) {
        this.setState({ errors });
    }

    optionalFieldIsBlank(fieldName){
        return this.props.opinion.notRequired[fieldName] && this.props.currentFormValues[fieldName] === ''
    }

    checkForBlurError(fieldName) {
        const errors = submissionErrorHandler(this.props.currentFormValues, validate);
        if (errors.includes(fieldName) && 
            !this.state.errors.includes(fieldName) && 
            !this.optionalFieldIsBlank(fieldName))
                this.setState({ errors: [...this.state.errors, fieldName] });
    }

    clearSubmitErrors(fieldName) {
        if (fieldName && this.state.errors.includes(fieldName)) {
            this.setState({ errors: this.state.errors.filter(e => e !== fieldName) });
        }
    }

    render() {
        return (
            <DetailsFormContainer autocomplete="on">
                <Row className="row-wrapper-1">
                    {this.props.capture.name &&
                        (<FullRow isShortRow={this.props.isShortRow}>
                            <Field
                                name="fullName"
                                submissionError={this.state.errors.includes('fullName')}
                                onBlur={() => this.checkForBlurError('fullName')}
                                clearSubmitErrors={this.clearSubmitErrors}
                                component={InputGroup}
                                type="text"
                                label={copyFor(
                                    'formFields',
                                    'fullName',
                                    'petition',
                                    capitalization.eachWord
                                )}
                                isOptional={this.props.opinion.notRequired["fullName"]}
                                placeholder={copyFor('placeholders', 'fullName', 'petition')}
                                paddingAdjustment={-3}
                                onFocus={this.props.onInitiated}
                            />
                        </FullRow>)
                    }
                    {this.props.capture.email &&
                        (<FullRow isShortRow={this.props.isShortRow}>
                            <Field
                                name="email"
                                onBlur={() => this.checkForBlurError('email')}
                                submissionError={this.state.errors.includes('email')}
                                clearSubmitErrors={this.clearSubmitErrors}
                                component={InputGroup}
                                type="email"
                                label={copyFor(
                                    'formFields',
                                    'emailAddress',
                                    'petition',
                                    capitalization.eachWord
                                )}
                                isOptional={this.props.opinion.notRequired["email"]}
                                placeholder={copyFor(
                                    'placeholders',
                                    'emailAddress',
                                    'petition'
                                )}
                                paddingAdjustment={-3}
                                onFocus={this.props.onInitiated}
                            />
                        </FullRow>)
                    }
                    {this.props.userInfoType &&
                        <FullRow
                            onBlur={() => this.checkForBlurError(this.props.userInfoType)}
                            isShortRow={this.props.isShortRow}
                        >
                            {this.props.capture.address ? (
                                <ReactGoogleAutocomplete
                                    submissionError={this.state.errors.includes('address')}
                                    clearSubmitErrors={this.clearSubmitErrors}
                                    formName={['petitionDetailsForm', 'google_autocomplete']}
                                    fields={['address_components', 'formatted_address']}
                                    types={['address']}
                                    setValidState={this.setValidState}
                                    paddingAdjustment={-3}
                                    onFocus={this.props.onInitiated}
                                    isOptional={this.props.opinion.notRequired["address"]}
                                />
                            ) : (<Field
                                    name={this.props.userInfoType}
                                    submissionError={this.state.errors.includes(
                                        this.props.userInfoType
                                    )}
                                    clearSubmitErrors={this.clearSubmitErrors}
                                    component={InputGroup}
                                    type={this.props.userInfoType}
                                    label={copyFor(
                                        'formFields',
                                        this.props.userInfoType,
                                        'petition',
                                        capitalization.eachWord
                                    )}
                                    isOptional={this.props.opinion.notRequired["postalCode"]}
                                    placeholder={copyFor(
                                        'placeholders',
                                        this.props.userInfoType,
                                        'petition'
                                    )}
                                    paddingAdjustment={-3}
                                    onFocus={this.props.onInitiated}
                                />)
                            }
                        </FullRow>
                    }
                    {this.props.isOpinionAction && 
                        <FullRow>
                            <Field
                                name="message"
                                title="message"
                                onBlur={() =>{
                                    this.setState({messageTextAreaFocused: false});
                                    this.checkForBlurError('message');
                                }}
                                onFocus={() => this.setState({messageTextAreaFocused: true})}
                                active={this.state.messageTextAreaFocused}
                                submissionError={this.state.errors.includes('message')}
                                clearSubmitErrors={this.clearSubmitErrors}
                                component={TextareaGroup}
                                isShortRow={this.props.isShortRow}
                                style={{height: this.props.opinion.messageHeight}}
                                type="text"
                                label={copyFor(
                                    'placeholders',
                                    'message'
                                )}
                                paddingAdjustment={-3}
                            />
                        </FullRow>
                    }
                </Row>
                <OptInsAndButtonGroup
                    currentFormValues={this.props.currentFormValues}
                    setValidState={this.setValidState}
                    clearSubmitErrors={this.clearSubmitErrors}
                    setSubmitErrors={this.setSubmitErrors}
                    buttonText={this.props.buttonText}
                    onSubmit={this.props.onSubmit}
                    hasABOptIn={this.props.hasABOptIn}
                    invalid={
                        this.props.invalid ||
                        (this.props.capture.address &&
                            !this.props.opinion.notRequired.address &&
                            !this.state.valid)
                    }
                    isCare2={this.props.isCare2}
                    isEU={!!this.props.endUserLocation.isEU}
                    isSubmitting={this.props.isSubmitting}
                    partnerOptIn={this.props.showPartnerOptIn}
                    partnerOptInText={this.props.partnerOptInText}
                    subscriptionOptInText={this.props.subscriptionOptInText}
                    validate={validate}
                    actionType={this.props.actionType}
                    opinionNotRequiredFields={this.props.opinion.notRequired}
                />
            </DetailsFormContainer>
        );
    }
}

PetitionForm.propTypes = {
    buttonText: PropTypes.string.isRequired,
    currentFormValues: PropTypes.object,
    endUserLocation: PropTypes.object.isRequired,
    onSubmit: PropTypes.func.isRequired,
    hasABOptIn: PropTypes.bool.isRequired,
    invalid: PropTypes.bool.isRequired,
    isCare2: PropTypes.bool.isRequired,
    isSubmitting: PropTypes.bool.isRequired,
    onInitiated: PropTypes.func.isRequired,
    partnerOptInText: PropTypes.string,
    showPartnerOptIn: PropTypes.bool.isRequired,
    subscriptionOptInText: PropTypes.string,
    userInfoType: PropTypes.string
};

export default compose(
    connect(state => {
        const activeAction = state.widget.activeAction;
        const actionType = activeAction.type;
        const isPetitionAction = actionType === 'petition';
        const isOpinionAction = actionType === 'opinion';

        let userInfoType;
        if (isPetitionAction) userInfoType = activeAction.requiredUserInfo || 'address';
        else if (isOpinionAction){
            if (activeAction.captureZipCode) userInfoType = 'postalCode'
            else if (activeAction.captureAddress) userInfoType = 'address'
        }
        const hasABOptIn = !activeAction.hideSubscriptionOptIn,
            showPartnerOptIn = activeAction.hasPartnerOptIn,
            initialValues = {
                getUpdates: !(state.widget.endUserLocation || {}).isEU && hasABOptIn,
                partnerOptIn: !(state.widget.endUserLocation || {}).isEU && showPartnerOptIn,
            };

        const capture = {
                name: activeAction.captureName || isPetitionAction,
                email: activeAction.captureEmail || isPetitionAction,
                postalCode: userInfoType === 'postalCode',
                address: userInfoType === 'address',
            };

        const opinionNotRequiredFields = {};
        if (isOpinionAction){
            opinionNotRequiredFields.fullName = !activeAction.nameRequired
            opinionNotRequiredFields.email = !activeAction.emailRequired
            opinionNotRequiredFields.postalCode = !activeAction.zipCodeRequired
            opinionNotRequiredFields.address = !activeAction.addressRequired
        }
        initialValues.notRequired = opinionNotRequiredFields;

        const numberOfFields = Object.values(capture).reduce((sum, field) => field ? sum+1 : sum, 0);
        const opinion = {
                notRequired: opinionNotRequiredFields,
                hideZipcode: isOpinionAction && !capture.postalCode,
                numberOfFields,
                messageHeight: `${150 - numberOfFields * 25}px`
            };

        if (userInfoType) initialValues[userInfoType] = state.cachedFormData[userInfoType] || '';
        if (isPetitionAction){
            initialValues.fullName = getCachedFullName(state);
            initialValues.email = state.cachedFormData.email || '';
        }
        else if (isOpinionAction){
            initialValues.message = '';
            if (capture.name) initialValues.fullName = getCachedFullName(state);
            if (capture.email) initialValues.email = state.cachedFormData.email || '';
        }

        return {
            actionType,
            buttonText:
                activeAction.customButtonText ||
                copyFor('buttons', 'submit', actionType, capitalization.eachWord),
            capture,
            currentFormValues: (state.form['petitionDetailsForm'] || {}).values,
            endUserLocation: state.widget.endUserLocation || {},
            hasABOptIn,
            initialValues,
            isCare2: !!activeAction.care2Id,
            isOpinionAction,
            isPetitionAction,
            isShortRow: opinion.numberOfFields > 1,
            localRepFullName:
                state.localRep.localRepData.representative !== undefined
                    ? state.localRep.localRepData.representative[0].fullName
                    : '',
            opinion,
            partnerOptInText:
                activeAction.partnerOptInText ||
                (activeAction.partner || {}).name,
            showPartnerOptIn,
            subscriptionOptInText: activeAction.subscriptionOptInText,
            userInfoType,
        };
    }),
    reduxForm({
        form: 'petitionDetailsForm',
        destroyOnUnmount: true,
        enableReinitialize: false,
        validate
    })
)(PetitionForm);
